import _isEqual from 'lodash/isEqual';

import {
  getCategoriesPayloadFromLessonForm,
  getLessonCategoryIdsFromApiLesson,
} from 'helpers/getLessonCategoryIdsFromApiLesson';

const omitTaskText = (tasks: unknown) => {
  if (!Array.isArray(tasks)) {
    return tasks;
  }

  return tasks.map((task) => {
    if (!task || typeof task !== 'object') {
      return task;
    }

    const { text, ...structuralTask } = task as Record<string, unknown>;

    return structuralTask;
  });
};

export const getChangedProperties = ({
  currentLesson,
  nextLesson,
}: {
  currentLesson: any;
  nextLesson: any;
}) => {
  const properties = [];

  if (currentLesson.title !== nextLesson.title) {
    properties.push('title');
  }

  if (!_isEqual(currentLesson.goals, nextLesson.goals)) {
    properties.push('goals');
  }

  if (currentLesson.free !== nextLesson.free) {
    properties.push('free');
  }

  if (currentLesson.designType !== nextLesson.designType) {
    properties.push('designType');
  }

  if (currentLesson.fileId !== nextLesson.fileId) {
    properties.push('fileId');
  }

  if (currentLesson.filePageId !== nextLesson.filePageId) {
    properties.push('filePageId');
  }

  if (!_isEqual(currentLesson.goodToKnowBlocks, nextLesson.goodToKnowBlocks)) {
    properties.push('goodToKnowBlocks');
  }

  if (!_isEqual(currentLesson.canvasTheory, nextLesson.canvasTheory)) {
    properties.push('canvasTheory');
  }

  if (!_isEqual(currentLesson.initialState, nextLesson.initialState)) {
    properties.push('initialState');
  }

  if (
    !_isEqual(
      omitTaskText(currentLesson.tasks),
      omitTaskText(nextLesson.tasks),
    )
  ) {
    properties.push('tasks');
  }

  if (!_isEqual(currentLesson.description, nextLesson.description)) {
    properties.push('description');
  }

  if (currentLesson.percentToComplete !== nextLesson.percentToComplete) {
    properties.push('percentToComplete');
  }

  if (currentLesson.resultRefPreview !== nextLesson.resultRefPreview) {
    properties.push('resultRefPreview');
  }

  if (
    !_isEqual(
      [...getLessonCategoryIdsFromApiLesson(currentLesson)].sort(),
      [...getCategoriesPayloadFromLessonForm(nextLesson)].sort(),
    )
  ) {
    properties.push('categories');
  }

  return properties;
};
